import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import { createDataAccessStore } from '@/store/stores/DataAcess-store';
import { StringObjectTuple } from '../types/types';
import DataAcessApi from './DataAccessApi';
import IBORTransactions from '../models/IBORTransactions';
import IDataTable from '../models/IDataTable';
import IBORTransactionDetails from '../models/IBORTransactionDetails';
export default class BORTransactionsApi extends BaseApi {
    idUser : string = "";
    dataAcess: any = null;

    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.dataAcess = createDataAccessStore('dataAcessListCitiesMain1');
        this.dataAcess.FormId = "Inbounds";
    }

    async Create(documentName: string, documentUrl: string, idInbound: string) : Promise<string> {
        let parameters : StringObjectTuple[];
        parameters = [['IdInbound', idInbound], ['documentName', documentName], ['documentUrl', documentUrl], ['User', this.idUser]];
        const api = new DataAcessApi("Inbounds8");
        try {
            const data = await api.ExecStructuredProcedure("BOR_TRANSACTION_CREATE", parameters, []);
            return data.records[0].idTransaction;
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return '';
    }

    async UpdatedSend(idTransaction: string, errorCode: number, errorDescription: string) {
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction], ['SendErrorCode', errorCode], ['SendErrorDescription', errorDescription], ['User', this.idUser]];
        const api = new DataAcessApi("Inbounds9");
        try {
            const data = await api.ExecStructuredProcedure("BOR_TRANSACTION_UPDATE_SEND", parameters, []);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
    }

    async UpdatedParse(idTransaction: string, errorCode: number, errorDescription: string) {
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction], ['ParseErrorCode', errorCode], ['ParseErrorDescription', errorDescription], ['User', this.idUser]];
        const api = new DataAcessApi("Inbounds10");
        try {
            const data = await api.ExecStructuredProcedure("BOR_TRANSACTION_UPDATE_PARSE", parameters, []);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
    }

    async UpdatedCompleted(idTransaction: string, errorCode: number, errorDescription: string) {
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction], ['CompletedErrorCode', errorCode], ['CompletedErrorDescription', errorDescription], ['User', this.idUser]];
        const api = new DataAcessApi("Inbounds11");
        try {
            const data = await api.ExecStructuredProcedure("BOR_TRANSACTION_UPDATE_COMPLETED", parameters, []);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
    }

    async Delete(idInbound: string, idTransaction: string) {
        let parameters : StringObjectTuple[];
        parameters = [['idInbound', idInbound], ['idTransaction', idTransaction], ['User', this.idUser]];
        const api = new DataAcessApi("Inbounds12");
        try {
            await api.ExecStructuredProcedure("BOR_TRANSACTION_DELETE", parameters, []);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
    }

    async Read(idInbound: string) : Promise<IBORTransactions[]> {
        let parameters : StringObjectTuple[];
        parameters = [['idInbound', idInbound]];
        const api = new DataAcessApi("Inbounds13");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("BOR_TRANSACTION_GET_ACTIVE_FOR_INBOUND", parameters, []);
            return this.MapToBORInboundDetailType(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }
    
    async ReadAll(): Promise<IBORTransactionDetails[]> {
        const api = new DataAcessApi("Inbounds14");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("BOR_TRANSACTION_READ_ALL", [], []);
            return this.MapToTransactionDetail(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async GetLogs(idTransaction: string): Promise<any> {
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction]];
        const api = new DataAcessApi("Inbounds15");
        try {
            const data = await api.ExecStructuredProcedure("BOR_GET_LOG", parameters, []);
            return data.records[0].htmlResult;
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return '';
    }

    MapToTransactionDetail(data: IDataTable): IBORTransactionDetails[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map(record => {
            return {
                id: record.id || "",
                idInbound: record.idinbound || "",
                documentName: record.documentName || "",
                documentUrl: record.documentUrl || "",
                sendDate: record.sendDate || new Date(),
                sendErrorCode: Number(record.sendErrorCode) || 0,
                sendErrorDescription: record.sendErrorDescription || "",
                parseDate: record.parseDate || new Date(),
                parseErrorCode: Number(record.sendErrorCode) || 0,
                parseErrorDescription: record.parseErrorDescription || "",
                completedDate: record.completedDate || new Date(),
                completedErrorCode: Number(record.completedErrorCode) || 0,
                completedErrorDescription: record.parseErrorDescription || "",
                createdBy: record.createdBy || "",
                createdDate: record.createdDate || new Date(),
                modifiedBy: record.modifiedBy || "",
                modifiedDate: record.modifiedDate || new Date(),
                deletedBy: record.deletedBy || "",
                deletedDate: record.deletedDate || new Date(),
                documentURL: record.documentURL || "",
                deleted: record.deleted || false,
                inboundCode: record.inboundCode || "",
                inboundDateIn: record.inboundDateIn || new Date(),
                companyName: record.companyName || "",
                customer: record.customer || ""
            };
        });
    }

    MapToBORInboundDetailType(data: IDataTable): IBORTransactions[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }
    
        return data.records.map(record => {
            return {
                id: record.id || "",
                idInbound: record.idinbound || "",
                documentName: record.documentName || "",
                documentUrl: record.documentUrl || "",
                sendDate: record.sendDate || new Date(),
                sendErrorCode: Number(record.sendErrorCode) || 0,
                sendErrorDescription: record.sendErrorDescription || "",
                parseDate: record.parseDate || new Date(),
                parseErrorCode: Number(record.sendErrorCode) || 0,
                parseErrorDescription: record.parseErrorDescription || "",
                completedDate: record.completedDate || new Date(),
                completedErrorCode: Number(record.completedErrorCode) || 0,
                completedErrorDescription: record.parseErrorDescription || ""
            };
        });
    }
}
